export const RESERVATION_GRADE_LABEL: Record<string, string> = {
  danger: '즉시대응',
  caution: '조치필요',
  recommended: '조치권장',
  stable: '성사유망',
};

export const RESERVATION_GRADE_HINT: Record<string, string> = {
  danger: '바로 대응이 필요한 회차 수',
  caution: '조치가 필요한 회차 수',
  recommended: '조치를 권하는 회차 수',
  stable: '성사 가능성이 높은 회차 수',
};

export const RESERVATION_GRADE_COLOR: Record<string, string> = {
  danger: '#fc4242',
  caution: '#f69000',
  recommended: '#1890ff',
  stable: '#00bf40',
};

export function reservationGradeLabel(grade?: string | null): string {
  if (!grade) return '-';
  return RESERVATION_GRADE_LABEL[grade] || grade;
}

export const RUN_STATUS_LABEL: Record<string, string> = {
  running: '진행 중',
  completed: '완료',
  failed: '실패',
  partial: '일부 실패',
};

export const RUN_STATUS_COLOR: Record<string, string> = {
  running: 'processing',
  completed: 'success',
  failed: 'error',
  partial: 'warning',
};

export function runStatusLabel(status?: string | null): string {
  if (!status) return '-';
  return RUN_STATUS_LABEL[status] || status;
}

export const ROUTING_MODE_LABEL: Record<string, string> = {
  full: '전체 재배정',
  incremental: '증분',
  skipped: '생략',
  maintenance: '유지',
};

export const ROUTING_MODE_COLOR: Record<string, string> = {
  full: 'blue',
  incremental: 'cyan',
  skipped: 'default',
  maintenance: 'purple',
};

export function routingModeLabel(mode?: string | null): string {
  if (!mode) return '-';
  return ROUTING_MODE_LABEL[mode] || mode;
}

export const GROUP_STATUS_LABEL: Record<string, string> = {
  complete: '완료',
  short: '보충 필요',
};

export function groupStatusLabel(status?: string | null): string {
  if (!status) return '-';
  return GROUP_STATUS_LABEL[status] || status;
}

export const ALERT_STATUS_LABEL: Record<string, string> = {
  sent: '발송',
  skipped: '건너뜀',
  failed: '실패',
  pending: '대기',
};

export const ALERT_STATUS_COLOR: Record<string, string> = {
  sent: 'success',
  skipped: 'default',
  failed: 'error',
  pending: 'processing',
};

export function alertStatusLabel(status?: string | null): string {
  if (!status) return '-';
  return ALERT_STATUS_LABEL[status] || status;
}

export const ALERT_TYPE_LABEL: Record<string, string> = {
  reservation_morning_batch: '아침 요약',
  reservation_grade_change: '등급 변경',
  product_auxiliary_weekly: '주간 보조지표',
  lc_capacity_filled: '라스트찬스 정원 마감',
  lc_deadline_today: '라스트찬스 마감일',
  lc_formed: '라스트찬스 성사',
};

export function alertTypeLabel(type?: string | null): string {
  if (!type) return '-';
  return ALERT_TYPE_LABEL[type] || type;
}

export const INVOCATION_TYPE_LABEL: Record<string, string> = {
  scheduled_hourly: '정기(매시)',
  scheduled_daily: '정기(매일)',
  scheduled_poll: '정기(확인)',
  manual: '수동',
};

export function invocationTypeLabel(type?: string | null): string {
  if (!type) return '-';
  return INVOCATION_TYPE_LABEL[type] || type;
}
